export default __webpack_public_path__ + "static/media/logoPark.28971ce7.svg";